import * as marietta from '../../..';

/**
 * 屋根テクスチャメニュークラス
 */
export default class RoofColorMenu {
  viewObj: Element;

  /**
   * コンストラクタ
   */
  constructor() {
    this.viewObj = document.getElementById('tabRoofColor');
  }

  /**
   * 初期化
   */
  init() {
    if (this.viewObj.children.length > 0) {
      this.viewObj.innerHTML = '';
    }
    this.createMaterialList();
  }

  /**
   * カラー（テクスチャ）リストの生成
   */
  createMaterialList() {
    // 情報をGET
    const roofData = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Roof);

    // コンテンツの作成
    let contents: string = '';
    contents += '<ul>';
    if (roofData !== undefined) {
      for (let i = 0; i < roofData.length; i += 1) {
        contents += `<li  data-itemindex="${String(i)}" class="btnChangeRoofColor"><button id="changeOutColorRoof${String(i)}"><img src="${roofData[i].thumbnail}" width="64" height="64"/><div class="currentFrame"></div><p>${roofData[i].name}</p></button></li>`;
      }
    }
    contents += '</ul>';
    this.viewObj.insertAdjacentHTML('beforeend', contents);

    document.querySelectorAll('.btnChangeRoofColor').forEach((elem) => {
      elem.addEventListener('click', (e) => {
        const itemIndex = Number(((e.currentTarget) as HTMLElement).getAttribute('data-itemindex'));
        marietta.view3d.webcad.View3dGlobal.shared.changeRoofColor(itemIndex);
      });
    });
    // カレントを表示
    this.initCurrentTexture();

    const self = this;
    (self.viewObj).querySelectorAll('li').forEach((elem) => {
      elem.addEventListener('click', self.updateCurrentTexture);
    });
  }

  /**
   * 選択状態の更新
   */
  initCurrentTexture() {
    // 情報をGET
    const roofData = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Roof);

    const self = this;
    roofData.forEach((obj, index) => {
      if (obj.selected) {
        (self.viewObj).querySelectorAll('li')[index].classList.add('is-active');
      } else {
        (self.viewObj).querySelectorAll('li')[index].classList.remove('is-active');
      }
    });
  }

  /**
   * 選択中のテクスチャをカレント表示
   */
  updateCurrentTexture = (e) => {
    (e.currentTarget).closest('.tabContentsWrap').querySelectorAll('li').forEach((elem) => {
      elem.classList.remove('is-active');
    });
    (e.currentTarget).classList.add('is-active');
  }
}
